var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kd-button"},[_c('div',{class:[
      'kd-button__btn',
      _vm.type === 'primary' ? 'kd-button__btn-primary' : '',
      _vm.round ? 'kd-button__btn-round' : ''
    ],style:(_vm.styleString),attrs:{"role":"button"},on:{"click":_vm.btnClick}},[(_vm.disabled)?_c('div',{class:[_vm.disabled ? 'kd-button__btn-disabled' : '']}):_vm._e(),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }